import React, { useEffect, useState } from "react"
import EcommerceConfiguration, {
    CreateEcommerceConfigurationDto
} from "../../../state/ecommerce-configuration/EcommerceConfigurationValues"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import EcommerceConfigurationService from "../../../state/ecommerce-configuration/EcommerceConfigurationService"
import { ECOMMERCE_CONFIGURATION_TYPE } from "../../../state/ecommerce-configuration/EcommerceTypes"
import { isError } from "../../../state/helpers/Error"
import EcommerceConfigurationTabs from "../components/EcommerceTabsComponent"
import EventBus from "../../../common/EventBus.js"
import { FormattedMessage } from "react-intl"
import { integrationKeyShopify } from "../../../integration/IntegrationConstants"
import { GlobalHelper } from "../../../indexImports"
import EcommerceContainer from "./EcommerceConfigurationContainer"
import LoadingSpinner from "../../../common/spinner/loading.component"
import EcommerceConfigurationList from "../components/EcommerceConfigurationList"
import QuoteFormConfiguration from "../../../state/ecommerce-configuration/EcommerceQuoteFormConfiguration"

const EcommerceConfigurationContainerWrapper = () => {
    const [ecommerceConfiguration, setEcommerceConfiguration] = useState<EcommerceConfiguration>()
    const [activeTab, setActiveTab] = useState<ECOMMERCE_CONFIGURATION_TYPE>(ECOMMERCE_CONFIGURATION_TYPE.QUOTE_CART)
    const [isSubmitEnabled, setIsSubmitEnabled] = useState<boolean>(true)
    const [loading, setLoading] = useState(true)
    const [formConfiguration, setFormConfiguration] = useState<QuoteFormConfiguration[]>([])

    useEffect(() => {
        (async () => {
            await GetEcommerceConfiguration()
        })()
    }, [])

    const GetEcommerceConfiguration = async () => {
        const acct = AppContext.getAccount().id
        const res = await EcommerceConfigurationService.GetEcommerceConfiguration(
            GlobalHelper.getIntegrationSupportingEcommerceConfiguration(),
            acct
        )
        if (!isError(res)) {
            const config = res as EcommerceConfiguration
            setEcommerceConfiguration(config)
            setLoading(false)
        }
    }

    const saveConfiguration = async (payload: CreateEcommerceConfigurationDto) => {
        setIsSubmitEnabled(false)
        const configuration = await EcommerceConfigurationService.UpdateEcommerceConfiguration(
            integrationKeyShopify,
            AppContext.getAccount().id,
            payload
        )
        if (!isError(configuration)) {
            setIsSubmitEnabled(true)
            setTimeout(() => {
                EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
                    message: <FormattedMessage
                        id='settings.sections.ecommerce_configuration_container_wrapper.update_success_message'
                        defaultMessage="Ecommerce configuration updated successfully"
                    />
                })
            }, 500)

        }
    }
    const handleEcommerceConfigurationOnChange = (payload: QuoteFormConfiguration[]) => {
        setFormConfiguration(payload)
    }

    return (
        <div>
            <EcommerceConfigurationTabs activeTab={activeTab} onChangeCallback={(tab) => { setActiveTab(tab) }} />
            {loading ?
                <LoadingSpinner className={"mt-5"} /> :

                <EcommerceContainer
                    configurationType={activeTab}
                    configuration={ecommerceConfiguration}
                    handleSubmitCallback={saveConfiguration}
                    isSubmitEnabled={isSubmitEnabled}
                    key={activeTab}
                    formConfiguration={formConfiguration}
                />
            }
            {activeTab == ECOMMERCE_CONFIGURATION_TYPE.QUOTE_FORM &&
                <EcommerceConfigurationList
                    configuration={ecommerceConfiguration}
                    handleUpdateCallback={handleEcommerceConfigurationOnChange}
                    handleSubmitCallback={saveConfiguration}
                    configurationType={activeTab}
                />}
        </div>
    )
}

export default EcommerceConfigurationContainerWrapper




// WEBPACK FOOTER //
// ./src/settings/ecommerce/sections/EcommerceConfigurationContainerWrapper.tsx